import { DropdownMenuComponentConfig } from './dropdown-menu.interface';

export interface DropdownMenuWrapper extends DropdownMenuComponentConfig {
    isVisible?: boolean;
}
